export default __webpack_public_path__ + "static/media/chandosBook@2x.aed767d0.jpg";